import { useQueryClient } from '@tanstack/react-query';

import { api, CARE_PLAN_ACTIVITY_NOTE_TITLE } from '@/api';
import { useIsDDFeatureFlagEnabled } from '@/core/data-dog';
import { useFctReport } from '@/shared/hook';

export const useCreateBreakTheGlassNote = () => {
  const isFeatureEnabled = useIsDDFeatureFlagEnabled('FCT_CARE_PLAN_NOTES');
  const { report } = useFctReport();
  const queryClient = useQueryClient();
  const createBreakTheGlassNoteMutation =
    api.fct.carePlanNotes.mutation.useCreateCarePlanActivityNote(queryClient);

  const handleCreateBreakTheGlassNote = (content: string) => {
    if (!isFeatureEnabled || !report?.careActivityId) {
      return;
    }

    if (createBreakTheGlassNoteMutation.isPending) {
      return;
    }

    createBreakTheGlassNoteMutation.mutate({
      payload: {
        activity_id: report.careActivityId,
        body: {
          content,
          title: CARE_PLAN_ACTIVITY_NOTE_TITLE.CRITICAL_RESULTS_NOTIFICATION,
        },
      },
    });
  };

  return {
    isCreatingBreakTheGlassNote: createBreakTheGlassNoteMutation.isPending,
    onCreateBreakTheGlassNote: handleCreateBreakTheGlassNote,
  };
};
